import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { round } from 'lodash'
import { D101_0, P155_1, P155_1_RATE, VP_003, VP_056, VP_152 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity, updateManyIndicatorEntity } from 'rpqs/utils/RPQSUtils'


const DialogP155_1 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntity] = useState(managementEntity)
    const [readMode, setReadMode] = useState(true)

    useEffect(() => {
        setEntity(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    useEffect(() => {
        if (!readMode) return

        const newIndicator = { ...currentEntity?.[P155_1.code], value: getIndicatorValue(VP_003) + getIndicatorValue(VP_152) }
        setEntity(updateIndicatorEntity(entityDialog, year, P155_1.code, newIndicator))
    }, [readMode])

    const rows = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_003.code,
            indicatorName: i18n[VP_003.i18n],
            unit: i18n.writtenComplaints,
            onChange: v => setEntity(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_003.code, value: { ...currentEntity?.[VP_003.code], value: parseInt(v) || 0 } },
                { code: P155_1.code, value: { ...currentEntity?.[P155_1.code], value: readMode ? parseInt(v) + getIndicatorValue(VP_152) : getIndicatorValue(P155_1) } },
            ]))),
        }),

        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_152.code,
            indicatorName: i18n[VP_152.i18n],
            unit: i18n.writtenComplaints,
            onChange: v => setEntity(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_152.code, value: { ...currentEntity?.[VP_152.code], value: parseInt(v) || 0 } },
                { code: P155_1.code, value: { ...currentEntity?.[P155_1.code], value: readMode ? parseInt(v) + getIndicatorValue(VP_003) : getIndicatorValue(P155_1) } },
            ]))),
        }),
        getIndicatorDialogRow({
            resumption: D101_0.name,
            entityDialog,
            rpqs,
            codeIndicator: VP_056.code,
            indicatorName: i18n[VP_056.i18n],
            unit: i18n.subscriber,
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            readMode,
            codeIndicator: P155_1.code,
            indicatorName: i18n[P155_1.i18n],
            unit: i18n.writtenComplaints,
            onChange: v => setEntity(prev => (updateIndicatorEntity(prev, year, P155_1.code,
                { ...currentEntity?.[P155_1.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntity(updateIndicatorEntity(entityDialog, year, P155_1_RATE.code, { ...currentEntity?.[P155_1_RATE.code], status }))
    }

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_056) != 0 ? round(getIndicatorValue(P155_1)/parseInt(currentEntity?.[VP_056.code]?.value)*1000, 2) : getIndicatorValue(P155_1)

        return updateIndicatorEntity(entityDialog, year, P155_1_RATE.code, { ...currentEntity?.[P155_1_RATE.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntity}
            codeIndicator={P155_1_RATE.code}
            readMode={readMode}
            setReadMode={setReadMode}
            calculationOnRegister={calculation}
        >
            {year && previousYear &&
                <Grid container direction={'column'} gap={2} size={12}>
                    <IndicatorHeaderDialog
                        current={{
                            year,
                            value: managementEntity?.[year]?.[P155_1_RATE.code]?.value,
                        }}
                        previous={{
                            year: previousYear,
                            value: managementEntity?.[previousYear]?.[P155_1_RATE.code]?.value,
                        }}
                        status={entityDialog?.[year]?.[P155_1_RATE.code]?.status}
                        onStatusChange={onStatusChange}
                        unit={i18n.nbComplaintsPerSubs}
                    />
                    <Divider/>
                    <IndicatorTable
                        year={year.toString()}
                        indicators={rows}
                    />

                </Grid>
            }
        </EntityIndicatorDialog>
    )
}

DialogP155_1.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP155_1
